var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.729 1.936l1.568 3.33 3.507.533c.664.101.932.958.45 1.452l-2.537 2.592.598 3.66c.115.7-.59 1.222-1.18.897L8 12.673 4.864 14.4c-.59.33-1.294-.2-1.179-.898l.599-3.659-2.538-2.591c-.483-.494-.214-1.35.45-1.452l3.507-.534 1.569-3.33c.273-.581 1.184-.581 1.457 0z",
    fill: "#EEB209",
    fillRule: "nonzero"
  })));
}
export default SvgStarFilled;